import axios from "axios";
import store from "../redux/store";
import { baseURL } from "../env";
import Cookies from 'js-cookie'



export const authAxios = axios.create({
    baseURL: baseURL + "/api",
    headers: {
        "Content-Type": "application/json",
        'access-control-allow-origin': '*',
       
  
    },
});



authAxios.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
if (err.response) {
    // Access Token was expired
    if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        
        try {
            // if (store.getState().login.isLogin)
            await myRefreshToken();
            
            console.log("middlewre authtoken " + authAxios.defaults.headers.common.Authorization);
                    originalConfig.headers.Authorization = authAxios.defaults.headers.common.Authorization
                    return authAxios(originalConfig);
                } catch (_error) {
                    if (_error.response && _error.response.data) {
                        return Promise.reject(_error.response.data);
                    }

                    return Promise.reject(_error);
                }
            }

            if (err.response.status === 403 && err.response.data) {
                return Promise.reject(err.response.data);
            }
        }

        return Promise.reject(err);
    }
);

const myRefreshToken = () => {

    return axios.post(baseURL+'/api/User/refresh-token',)
        .then((response) => {
            var token = response.data.token;
            authAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
            Cookies.set('auth',  `${token}`)
        }, (error) => {
            console.log(error);

        });


}
